"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data_1) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.colCount = 0;
                        this.colSettingPairs = appn.emptyString;
                        this.dFilter = appn.emptyString;
                        this.showDataTable = false;
                        this.userList = [];
                        this.selectedFormId = appn.emptyString;
                        this.selectedScreenKey = appn.emptyString;
                        this.selectedFormName = appn.emptyString;
                        this.selectedVersionNo = appn.emptyString;
                        this.dataTrash = appn.emptyString;
                        this.maxColLimit = 0;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                const _maxColReorderLimit = 50;
                function init(args) {
                    _initArgs = args;
                    appn.dataView.init();
                    if (_initArgs.showDataTable) {
                        createDataTable();
                        appn.dateFilter.init(_initArgs.dFilter);
                        addEvents();
                        if (_initArgs.colCount > _maxColReorderLimit)
                            appn.toast.notify(appn.toast.Type.info, T('Column reordering is disabled because this entry has more than {0} columns.', _maxColReorderLimit));
                        if (_initArgs.colCount >= _initArgs.maxColLimit)
                            appn.toast.notify(appn.toast.Type.info, T('Table columns beyond {0} have been hidden due to performance reasons.', _initArgs.maxColLimit));
                    }
                }
                index_1.init = init;
                function addEvents() {
                    $('#manageForm .card-tools button').click(function (event) {
                        event.preventDefault();
                        $(this).closest('.modal-dialog').find('.loadingOverlay-modal').show();
                        if ($(this).val() === 'Trash') {
                            appn.dialog.hide();
                            const submitButton = $('#manageScreensDialog .card-header button[value="Manage_Trash"].btn-danger');
                            const selectedItems = $('.selectRow:checked');
                            const msgDetail = createTrashMessageFromTable(submitButton, selectedItems);
                            const detail = appn.elementBuilder.createElement('p', undefined, undefined, undefined, JSON.parse(msgDetail));
                            const message = appn.elementBuilder.createElement('p', undefined, undefined, undefined, T('You will have 30 days to restore from the Trash area before the item(s) are permanently deleted from the system.'));
                            const confirmation = appn.elementBuilder.createElement('p', 'trash-confirm-msg', undefined, undefined, T('Hit the <b>Trash</b> button to proceed.'));
                            const buttonConfig = {
                                trash: {
                                    label: '<span>' + T('Trash') + '</span>' + '<i class="fa fa-trash"></i>',
                                    className: 'btn-success',
                                    callback: function (result) {
                                        if (!result)
                                            return;
                                        appn.dialog.showLoading();
                                        appn.ajax.post({
                                            url: _initArgs.dataTrash,
                                            data: $('#manageForm').serialize(),
                                            done: function () {
                                                _dataTable.fnDraw(false);
                                                appn.dialog.hide();
                                                appn.ui.disableElement($('#manageDataBtn'));
                                                appn.toast.notify(appn.toast.Type.info, T('Selected Form Entries successfully moved to Trash'));
                                            },
                                            fail: function () {
                                                appn.dialog.hide();
                                                $('#deleteOverlay').css('display', 'none');
                                                $('#deleteErrorMessage').css('display', 'inline');
                                                setTimeout(function () {
                                                    $('#deleteErrorMessage').css('display', 'none');
                                                }, 5000);
                                                appn.toast.notify(appn.toast.Type.error, T('Unable to move selected Form Entries to Trash'));
                                            },
                                            always: function () {
                                                appn.dialog.hideLoading();
                                            }
                                        });
                                    }
                                }
                            };
                            appn.dialog.custom({
                                modalColor: 'modal-danger',
                                title: T('Move To Trash?'),
                                message: detail.outerHTML + message.outerHTML + '<br>' + confirmation.outerHTML,
                                className: 'appnGlobalConfirmTrash',
                                isTrashAction: true,
                                closeButton: true,
                                buttons: buttonConfig
                            });
                            return;
                        }
                        appn.dialog.showLoading();
                        const currentCard = $(this).closest('.card');
                        const isProtectFromCurrentCard = currentCard.find('.export-manage-isProtect-checkbox');
                        if (appn.utils.hasValue(isProtectFromCurrentCard)) {
                            const currentValue = isProtectFromCurrentCard.is(':checked');
                            $('#manageForm input[name="IsProtectData"]').remove();
                            $('#manageForm').append(`<input name="IsProtectData" value="${currentValue}" type="hidden">`);
                        }
                        const embedImageLinksCurrentCard = currentCard.find('.export-manage-embedImageLinks-checkbox');
                        if (appn.utils.hasValue(embedImageLinksCurrentCard)) {
                            const currentValue = embedImageLinksCurrentCard.is(':checked');
                            $('#manageForm input[name="EmbedImageLinks"]').remove();
                            $('#manageForm').append(`<input name="EmbedImageLinks" value="${currentValue}" type="hidden">`);
                        }
                        if (String($(this).val()).contains('Bulk'))
                            appn.dialog.bulkEntryExport.bulkExportSetValues(String($(this).val()));
                        appn.ajax.post({
                            url: 'Export/' + $(this).val(),
                            data: $('#manageForm').serialize(),
                            done: function () {
                                appn.notifications.updateNotificationTotal();
                                appn.ui.showExportConfirmation('Bulk Entry');
                            },
                            always: function () {
                                appn.dialog.hide();
                                appn.dialog.hideLoading();
                            }
                        });
                    });
                    $(document).on('click', 'a[id^="viewGroup_"]', function (e) {
                        e.preventDefault();
                        return appn.ui.popup(this);
                    });
                }
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        scrollX: '100%',
                        sDom: appn.dataTable.genSDom(3, 0, 2, '', 'RC'),
                        iDisplayLength: 50,
                        stateSave: _initArgs.colCount <= _maxColReorderLimit,
                        stateSaveCallback: function (oSettings, oData) {
                            appn.localStorage.setItem(appn.dataTable.getCompositeStateCacheKey(oSettings, getSuffix()), JSON.stringify(oData));
                        },
                        stateLoadCallback: function (oSettings) {
                            return JSON.parse(appn.localStorage.getItem(appn.dataTable.getCompositeStateCacheKey(oSettings, getSuffix())));
                        },
                        oColReorder: {
                            realtime: false,
                            iFixedColumns: 4,
                            reorderCallback: function () {
                                appn.dialog.singleEntryExport.init();
                                appn.dataTable.toggleOnRowChecked();
                            }
                        },
                        autoWidth: true,
                        bSort: true,
                        sAjaxSource: 'Data/DataTable',
                        fnServerData: function (data) {
                            const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', _initArgs.selectedFormId), { name: 'sCustom_1', value: appnDateFilterValue.type }, { name: 'sCustom_2', value: appnDateFilterValue.fromDate }, { name: 'sCustom_3', value: appnDateFilterValue.toDate }, appn.dataTable.getStateOrDefault('sCustom_4', $('#EntryId').val()), appn.dataTable.getStateOrDefault('sCustom_5', $('#sCustom_5').val()));
                        },
                        aaSorting: [[1, appn.IDTSortDir.desc]],
                        aoColumns: getDtColConfiguration(),
                        fnInitComplete: function () {
                            if (_initArgs.userList.length > 0)
                                $('.dataTables_filter').prepend(appn.elementBuilder.buildAppnSelect(_initArgs.userList, 'sCustom_5', 'saveMeState select2-noinit'));
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'importEntriesBtn', buttonType: 'Import' }
                            ], appn.requestUser.isSuperUserOrLoggedInAs);
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'manageDataBtn', buttonType: 'Manage', isDataTableToggleBtn: true, buttonText: T('Manage Data') }
                            ], true, true);
                            if ($('.select-form-version'))
                                $('.dataTables_controls_start').last().append($('.select-form-version'));
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#importEntriesBtn').click(function (e) {
                                e.preventDefault();
                                $('#importDialog').modal('show');
                            });
                            $('#manageDataBtn').click(function (e) {
                                e.preventDefault();
                                if (!$(this).prop('disabled')) {
                                    $('#manageForm input:not(.NoRemoval)').remove();
                                    $('.selectRow:checked').each(function (index) {
                                        $('#manageForm').append('<input type="hidden" name="SelectedEntries[' + index + ']" value="' + $(this)[0].id + '" />');
                                    });
                                    $('#manageForm').append(`<input type="hidden" name="SelectedFormId" value="${_initArgs.selectedFormId}" />`);
                                    $('#manageForm').append(`<input type="hidden" name="SelectedScreenKey" value="${_initArgs.selectedScreenKey}" />`);
                                    $('#manageForm').append(`<input type="hidden" name="SelectedFormName" value="${_initArgs.selectedFormName}" />`);
                                    $('#manageForm').append(`<input type="hidden" name="SelectedVersion" value="${_initArgs.selectedVersionNo}" />`);
                                    $('#manageForm').append('<input type="hidden" name="FromDate" value="' + $('#FromDate').val() + '" />');
                                    $('#manageForm').append('<input type="hidden" name="ToDate" value="' + $('#ToDate').val() + '" />');
                                    $('#manageForm').append('<input type="hidden" name="SelectedFileName" value="" />');
                                    $('#manageForm').append('<input type="hidden" name="SelectedTemplate" value="" />');
                                    $('#exportDialog').modal('show');
                                    appn.dialog.bulkEntryExport.init();
                                }
                                return false;
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.'));
                            appn.dialog.singleEntryExport.init();
                            appn.saveMeState.init(function () {
                                $('#EntryId').val(appn.emptyString);
                                _dataTable.fnDraw(false);
                            }, function () {
                                $('#EntryId').val(appn.emptyString);
                                _dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                            appn.select.init({ selector: '#sCustom_5', minimumResultsForSearch: '25' });
                        },
                        fnDrawCallback: function () {
                            appn.dialog.singleEntryExport.init();
                            $('td').on('click', 'a#viewMedia', function (event) {
                                event.preventDefault();
                                appn.dialog.viewMediaFromElement($(this));
                            });
                        }
                    });
                }
                function getSuffix() {
                    return '_' + $('#SelectedScreenKey').val().substring(0, 8) + '_' + $('#SelectedVersionNo').val();
                }
                function getDtColConfiguration() {
                    const aoColumns = [];
                    const columnSettingConfigs = [];
                    const columns = _initArgs.colSettingPairs.split('|');
                    columns.forEach(function (column, index) {
                        const settings = column.split(',');
                        const settingsConfig = {
                            sortable: JSON.parse(settings[0]),
                            name: settings[1],
                            width: settings[2]
                        };
                        columnSettingConfigs.push(settingsConfig);
                    });
                    columnSettingConfigs.forEach(function (columnSetting, index) {
                        if (columnSetting.name.toLowerCase() === appn.emptyString)
                            aoColumns.push({
                                bSortable: columnSetting.sortable,
                                sWidth: columnSetting.width,
                                sName: columnSetting.name,
                                sDefaultContent: appn.emptyString
                            });
                        else if (columnSetting.name.toLowerCase() === 'location')
                            aoColumns.push({
                                bSortable: columnSetting.sortable,
                                sWidth: columnSetting.width,
                                sName: columnSetting.name,
                                sDefaultContent: appn.emptyString,
                                sType: appn.IDTColumnType.html
                            });
                        else
                            aoColumns.push({
                                bSortable: columnSetting.sortable,
                                sWidth: columnSetting.width,
                                sName: columnSetting.name,
                                sDefaultContent: appn.emptyString
                            });
                    });
                    return aoColumns;
                }
                function createTrashMessageFromTable(button, selectedRows) {
                    let msg;
                    button.attr('data-trashdetail', appn.emptyString);
                    const formName = $('#SelectedScreenKey option[selected]').text();
                    const formVersion = $('#SelectedVersionNo option[selected]').text();
                    if (selectedRows.length > 1) {
                        const ul = appn.elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
                        selectedRows.each(function (index, selected) {
                            const name = $($(selected).closest('tr').find('td')[2]).text();
                            const dateTime = $($(selected).closest('tr').find('td')[1]).clone()
                                .children()
                                .remove()
                                .end()
                                .text()
                                .trim();
                            const item = T('<b>Entry by {0} ({1})</b>', name, dateTime);
                            const li = appn.elementBuilder.createElement('li', undefined, undefined, undefined, item);
                            ul.appendChild(li);
                        });
                        msg = T('The following entries from the form <b>{0} (Version - {1})</b> will be moved to Trash and will no longer be available for use.', formName, formVersion) + ul.outerHTML;
                    }
                    else {
                        const name = $($(selectedRows[0]).closest('tr').find('td')[2]).text();
                        const dateTime = $($(selectedRows[0]).closest('tr').find('td')[1]).clone()
                            .children()
                            .remove()
                            .end()
                            .text()
                            .trim();
                        msg = T('<b>Entry by {0} ({1})</b> from the form <b>{2} (Version - {3})</b> will be moved to Trash and will no longer be available for use.', name, dateTime, formName, formVersion);
                    }
                    const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                    return JSON.stringify(p.outerHTML);
                }
            })(index = data_1.index || (data_1.index = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
